// import geoRedClient from "~/api/geored-api";
import geoRedEcoClient from '~/api/geored-eco-api'
import Helpers from '~/services/helpers'
import cache from '~/utils/cache'
import circuit from './circuit'
import vehicle from './vehicle'
import driver from './driver'
import chart from './chart'

let ecoApi = geoRedEcoClient()

function getNewState() {
  return {
    initialized: false,
    show_menu_bloc: true,
    show_menu_table: false,
    showMultipleDate: false,
    showRangeDate: true,
    loading: true,
    selectedTab: 'car',
    dates: [],
    datesNow: [],
    showSelectedDate: '',
    selectedDate: null,
    checkedCategoriesIdList: [],
    ecoResults: [],
    dateRange: [],
    ...circuit.state,
    ...vehicle.state,
    ...driver.state,
    ...chart.state,
  }
}

export function createSortByField(field) {
  if (!field) {
    throw new Error('field required')
  }
  return (a, b) => {
    return (a[field] || '').toLowerCase() > (b[field] || '').toLowerCase()
      ? 1
      : -1
  }
}

async function getCurrentClientIdFromCache() {
  let userInfos = await cache.getItem('user_infos')
  return userInfos.toClientId || userInfos.clientId || userInfos.client_id
}

export default {
  namespaced: true,

  state: getNewState(),
  getters: {
    getShowMenuBloc(state) {
      return state.show_menu_bloc
    },
    getShowMenutable(state) {
      return state.show_menu_table
    },
    getLoading(state) {
      return state.loading
    },
    getSelectedTab(state) {
      return state.selectedTab
    },
    getCheckedCategoriesIdList(state) {
      return state.checkedCategoriesIdList
    },
    getSelectedDate(state) {
      return state.selectedDate
    },
    getEcoResults(state) {
      return state.ecoResults
    },
    getDates(state) {
      return state.dates
    },
    getDatesNow(state) {
      return state.datesNow
    },
    getShowMultipleDate(state) {
      return state.showMultipleDate
    },
    getShowRangeDate(state) {
      return state.showRangeDate
    },
    getShowSelectedDate(state) {
      return state.showSelectedDate
    },
    /**
     * give average rating for all EcoResults
     * needed because of a computing mistake saved in database before 2024/06
     * @param state
     * @returns {number}
     */
    getEcoResultsAvrRating(state) {
      if (!state.ecoResults.length) {
        return 0
      } else {
        let sum = 0
        for (const res of state.ecoResults) {
          sum += res.rating
        }
        return Math.round((sum / state.ecoResults.length) * 10) / 10
      }
    },
    ...circuit.getters,
    ...vehicle.getters,
    ...driver.getters,
    ...chart.getters,
  },
  mutations: {
    setInitialized(state) {
      state.initialized = true
    },
    resetState(state) {
      state.loading = true
      state = Object.assign(state, {
        ...state,
        ...getNewState(),
      })
    },
    setShowMenuBloc(state, val) {
      return (state.show_menu_bloc = val)
    },
    setShowMenutable(state, val) {
      return (state.show_menu_table = val)
    },
    setLoading(state, val) {
      return (state.loading = val)
    },
    setShowMultipleDate(state, val) {
      return (state.showMultipleDate = val)
    },
    setShowRangeDate(state, val) {
      return (state.showRangeDate = val)
    },
    setSelectedTab(state, infos = null) {
      state.selectedTab = infos || null
    },
    setCheckedCategoriesIdList(state, infos = []) {
      state.checkedCategoriesIdList = infos || []
    },
    setSelectedDate(state, infos = null) {
      state.selectedDate = infos || null
    },
    setEcoResults(state, infos = []) {
      // recalcul de la note global
      infos = infos.map((info) => {
        if (typeof info.ratingIdleExcess === 'undefined') {
          let sumRatio = 0
          let sumWeightedScore = 0
          const scoreKeys = [
            'ratingIdleExcess',
            'ratingAccelerateExcess',
            'ratingEngineUnder',
            'ratingEngineOver',
            'ratingFreewheel',
            'ratingBrake',
          ]
          info.ratingIdleExcess = 10
          for (const name of scoreKeys) {
            const k = name + 'Ratio'
            // on ignore la pondération d'une note si elle n'est pas définie
            if (typeof info[name] != 'undefined') {
              sumRatio += info.altData[k]
              sumWeightedScore += info[name] * info.altData[k]
            }
          }
          info.rating = Math.round((sumWeightedScore / sumRatio) * 10) / 10 // *10)/10 pour obtenir un arrondi à 1 décimale
        }
        return info
      })
      state.ecoResults = infos || []
    },
    setDates(state, infos = []) {
      state.dates = infos || null
    },
    setDatesNow(state, infos = []) {
      state.datesNow = infos || null
    },
    setShowSelectedDate(state, infos = null) {
      state.showSelectedDate = infos || null
    },
    setDateRange(state, range = []) {
      state.dateRange = range
    },
    ...circuit.mutations,
    ...vehicle.mutations,
    ...driver.mutations,
    ...chart.mutations,
  },
  actions: {
    ...circuit.actions,
    ...chart.actions,
    ...vehicle.actions,
    ...driver.actions,
    resetState({ commit }) {
      commit('resetState')
    },
    setDateRange({ commit }, range) {
      commit('setDateRange', range)
    },
    async switchToBloc({ commit }) {
      commit('setShowMenuBloc', true)
      commit('setShowMenutable', false)
    },
    async switchPeriode({ commit, getters }) {
      commit('setShowMultipleDate', !getters.getShowMultipleDate)
      commit('setShowRangeDate', !getters.getShowRangeDate)
    },
    async switchToTable({ commit }) {
      commit('setShowMenuBloc', false)
      commit('setShowMenutable', true)
    },
    async initialize({ state, commit, dispatch }) {
      if (state.initialized) {
        return
      } else {
        commit('setInitialized')
      }
      // let geoApi = geoRedClient();

      //Vehicles
      await dispatch('initializeVehicle')

      //Drivers
      await dispatch('initializeDriver')

      //Circuits
      await dispatch('initializeCircuit')

      commit('setLoading', false)
    },
    async processingDates({ commit, getters }) {
      console.log('eco:processingDates')
      commit('setShowSelectedDate', '')
      commit('setDates', [])
      commit('setDatesNow', [])
      let helpers = Helpers()
      let stringRangeDates = []
      let arrayRangeDatesNow = []
      if (getters.getShowRangeDate) {
        let splitedDate = getters.getSelectedDate.split(' ').join('').split('-')
        commit('setShowSelectedDate', `${splitedDate[0]}, ${splitedDate[1]}`)
        let startDate = helpers.reformatDateString(splitedDate[0])
        let endDate = helpers.reformatDateString(splitedDate[1])
        let rangeDates = helpers.getDatesBetweenDates(startDate, endDate)
        stringRangeDates = rangeDates.join('&date[]=')
        console.log('eco:processingDates:range', {
          stringRangeDates,
        })
      }
      if (getters.getShowMultipleDate) {
        let splitedDate = getters.getSelectedDate.split(' ').join('').split('-')
        let dates = splitedDate.slice(0, splitedDate.length - 1)
        let multipleDates = dates.map((date) =>
          helpers.reformatDateString(date)
        )

        commit('setShowSelectedDate', dates.join(', '))

        stringRangeDates = multipleDates.join('&date[]=')
        console.log('eco:processingDates:multiple', {
          stringRangeDates,
        })
      }
      commit('setDatesNow', arrayRangeDatesNow)
      commit('setDates', stringRangeDates)
    },

    async carEcoResultsData({ commit, getters, dispatch }) {
      await dispatch('processingDates')
      let ecoResultsVehicule = []
      if (getters.getDates != null) {
        console.log('search:vehicle:action:api-call')
        ecoResultsVehicule = await ecoApi.fetchVehiculePaginate(
          getters.getDates,
          await getCurrentClientIdFromCache(),
          getters.getCheckedCategoriesIdList
            .map((id) => `vehicleId[]=${id}`)
            .join('&')
        )
      } else {
        console.log('search:vehicle:action:no-dates')
      }
      // if (getters.getDatesNow.length > 0) {
      //   let ecoResultsVehiculeNow = await ecoApi.fetchVehiculeNow(
      //     getters.getDatesNow,
      //     userInfos.client_id,
      //     getters.getCheckedCategoriesIdList
      //   );
      //   if (typeof ecoResultsVehiculeNow != "undefined") {
      //     for (let datum in ecoResultsVehiculeNow) {
      //       ecoResultsVehicule.push(ecoResultsVehiculeNow[datum]);
      //     }
      //   }
      // }
      commit('setEcoResults', ecoResultsVehicule)
    },
    async driverEcoResultsData({ commit, getters, dispatch }) {
      await dispatch('processingDates')
      let ecoResultsDriver = []
      if (getters.getDates != null) {
        ecoResultsDriver = await ecoApi.fetchDriverPaginate(
          getters.getDates,
          await getCurrentClientIdFromCache(),
          getters.getCheckedCategoriesIdList
            .map((id) => `driverId[]=${id}`)
            .join('&')
        )
      }
      // if (getters.getDatesNow.length > 0) {
      //   let ecoResultsNowDriver = await ecoApi.fetchDriverNow(
      //     getters.getDatesNow,
      //     userInfos.client_id,
      //     getters.getCheckedCategoriesIdList
      //   );
      //   if (typeof ecoResultsNowDriver != "undefined") {
      //     for (let datum in ecoResultsNowDriver) {
      //       ecoResultsDriver.push(ecoResultsNowDriver[datum]);
      //     }
      //   }
      // }
      commit('setEcoResults', ecoResultsDriver)
    },
    async circuitEcoResultsData({ commit, getters, dispatch }) {
      commit('setEcoResults', [])
      await dispatch('processingDates')
      let ecoResultsCircuit = []
      if (getters.getDates != null) {
        ecoResultsCircuit = await ecoApi.fetchCircuitPaginate(
          getters.getDates,
          await getCurrentClientIdFromCache(),
          getters.getCheckedCategoriesIdList
            .map((id) => `roundId[]=${id}`)
            .join('&')
        )
      }
      // if (getters.getDatesNow.length > 0) {
      //   let ecoResultsNowCircuit = await ecoApi.fetchCircuitNow(
      //     getters.getDatesNow,
      //     userInfos.client_id,
      //     getters.getCheckedCategoriesIdList
      //   );
      //   if (typeof ecoResultsNowCircuit != "undefined") {
      //     for (let datum in ecoResultsNowCircuit) {
      //       ecoResultsCircuit.push(ecoResultsNowCircuit[datum]);
      //     }
      //   }
      // }
      commit('setEcoResults', ecoResultsCircuit)
    },
  },
}
